import React from 'react';
import { useCommonSelector } from '@wajeez-web/stores/common';
import { Transition } from '@headlessui/react';

export interface WajeezPageContainerProps {
  title: string;
  desc?: string;
}

const WajeezPageContainer = ({
  title,
  desc,
  children,
}: React.PropsWithChildren<WajeezPageContainerProps>) => {
  const { innerPageSideBarCollapsed } = useCommonSelector(
    (state) => state.common.settings
  );

  return (
    <div
      className={`grid grid-cols-5 overflow-hidden bg-white h-inner-screen `}
    >
      <Transition
        className={'h-full'}
        show={!innerPageSideBarCollapsed}
        // enter="transition-all ease duration-1000 transform"
        // enterFrom="w-0"
        // enterTo="w-full"
        // leave="transition-all ease   transform"
        // leaveFrom="w-full"
        // leaveTo="w-0"
      >
        <div
          className={`h-full  overflow-hidden bg-white border-e shadow-lg border-warmGray-200`}
        >
          <div className="py-4 divide-y   space-y-4">
            <div className=" px-2 text-center">
              <h3 className="text-lg font-bold  text-gray-900">
                {title.split('"')[0]}
              </h3>
              {title.split('"')[1] && (
                <h3 className="text-base font-semibold  text-gray-900">
                  " {title.split('"')[1]} "
                </h3>
              )}
              <p className="mt-1 text-sm text-gray-600">{desc}</p>
            </div>
          </div>
        </div>
      </Transition>
      <div
        className={`h-full  md:mt-0 flex-1  ${
          innerPageSideBarCollapsed ? 'col-span-5' : 'col-span-4'
        } flex-grow overflow-y-auto focus:outline-none space-y-10  `}
      >
        <div className="w-full h-full">
          <div className={`col-span-3 sm:grid-cols-3`}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default WajeezPageContainer;
